export const IS_BROWSER =
  typeof window !== "undefined" && typeof window.document !== "undefined";
export const WINDOW: any = IS_BROWSER ? window : {};
export const IS_TOUCH_DEVICE = IS_BROWSER
  ? "ontouchstart" in WINDOW.document.documentElement
  : false;
export const HAS_POINTER_EVENT = IS_BROWSER ? "PointerEvent" in WINDOW : false;

// Native events
export const EVENT_TOUCH_END = IS_TOUCH_DEVICE ? "touchend" : "mouseup";
export const EVENT_TOUCH_CANCEL = IS_TOUCH_DEVICE ? "touchcancel" : "mouseup";
export const EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? "touchmove" : "mousemove";
export const EVENT_TOUCH_START = IS_TOUCH_DEVICE ? "touchstart" : "mousedown";
export const EVENT_POINTER_DOWN = HAS_POINTER_EVENT
  ? "pointerdown"
  : EVENT_TOUCH_START;
export const EVENT_POINTER_MOVE = HAS_POINTER_EVENT
  ? "pointermove"
  : EVENT_TOUCH_MOVE;
export const EVENT_POINTER_UP = HAS_POINTER_EVENT
  ? "pointerup"
  : EVENT_TOUCH_END;
export const EVENT_POINTER_CANCEL = HAS_POINTER_EVENT
  ? "pointercancel"
  : EVENT_TOUCH_CANCEL;
